import { gsap } from 'gsap/dist/gsap';

export function contractIcons() {

  const buttons = Array.from(document.querySelectorAll('[data-button-contract]'))

  if (buttons) {

    buttons.forEach(button => {
      const iconTop = button.querySelector('.icon-top svg')
      const iconBottom = button.querySelector('.icon-bottom svg')
      
      button.addEventListener('mouseenter', () => {
        gsap.to(iconTop, { yPercent: 0, duration: 0.5, ease: 'circ.inOut' })
        gsap.to(iconTop, { xPercent: 0, duration: 0.5, ease: 'circ.inOut' })
        gsap.to(iconBottom, { yPercent: 0, duration: 0.5, ease: 'circ.inOut' })
        gsap.to(iconBottom, { xPercent: 0, duration: 0.5, ease: 'circ.inOut' })
      })
      
      button.addEventListener('mouseleave', () => {
        gsap.to(iconTop, { yPercent: -15, duration: 0.5, ease: 'circ.inOut' })
        gsap.to(iconTop, { xPercent: -15, duration: 0.5, ease: 'circ.inOut' })
        gsap.to(iconBottom, { yPercent: 15, duration: 0.5, ease: 'circ.inOut' })
        gsap.to(iconBottom, { xPercent: 15, duration: 0.5, ease: 'circ.inOut' })
      })

    });

  }

}


// WEBPACK FOOTER //
// ./scripts/animation/contract-icons.js